<router-outlet></router-outlet>
<app-loader></app-loader>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
